export default __webpack_public_path__ + "static/media/icon-brokers.fc6e8117.svg";